'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';

interface ErrorProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}

const WidgetInitError = ({ error }: ErrorProps) => {
  const t = useTranslations('Widget.pages.steps.errors');

  useEffect(() => {
    // Optionally log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <main className='flex h-full flex-col items-center justify-center p-4'>
      <h1 className='text-center vp-title-s'>{t('title')}</h1>
      <h2 className='text-center vp-body-m'>{t('description')}</h2>
      <p className='text-center vp-body-m mt-2'>{error?.message}</p>
    </main>
  );
};

export default WidgetInitError;
